// PortalAwareDraggable.js
import React from "react";
import ReactDOM from "react-dom";
import { Draggable } from "@hello-pangea/dnd";

/**
 * PortalAwareDraggable
 * A wrapper around Draggable that, if snapshot.isDragging,
 * portals the element to the <body> (or a dedicated portal root).
 *
 * Props:
 *  - draggableId: string
 *  - index: number
 *  - children: function or JSX to render inside
 */
export default function PortalAwareDraggable({ draggableId, index, children }) {
  // For the portal root, you can choose document.body,
  // or a dedicated <div id="draggable-portal" /> in your index.html
  const portalRoot = document.getElementById("draggable-portal") || document.body;

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => {
        // Normal element (while not dragging)
        const child = (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={provided.draggableProps.style}
            className="option-item"
          >
            {children}
          </div>
        );

        // If not dragging, return normally
        if (!snapshot.isDragging) {
          return child;
        }

        // If dragging, portal it to avoid transform offset issues
        return ReactDOM.createPortal(child, portalRoot);
      }}
    </Draggable>
  );
}
